$(function () {

    $(document).ready(function(){

      var summernoteFonts = ['Muli', 'Helvetica Neue', 'Helvetica', 'Roboto', 'Arial', 'sans-serif', 'Gotham-Dark', 'Montserrat-Bold', 'Montserrat-Dark', 'Rustico-Regular', 'Rubik-Dark', 'Rubik-Regular', 'Bariol-Regular', 'Georgia-Regular', 'Lato-Regular', 'Santander-Regular', 'Futura-Regular'];

      // Google Material Icons ligature conversion
      // This ensures all md icons use ligatures instead of class names
      function convertMaterialIcons() {
          $('.md').each(function() {
              var $icon = $(this);
              // Skip if already converted
              if ($icon.data('converted')) return;
              
              var classes = $icon.attr('class').split(' ');
              
              // Find the icon name class (format: md_icon_name)
              var iconClass = classes.find(function(className) {
                  return className.startsWith('md_') && className !== 'md';
              });
              
              if (iconClass) {
                  // Extract icon name and set as text content
                  var iconName = iconClass.substring(3); // Remove 'md_' prefix
                  
                  // Clear any existing content and set the ligature
                  $icon.empty().text(iconName);
                  
                  // Remove the specific icon class, keep other classes
                  $icon.removeClass(iconClass);
                  
                  // Mark as converted to avoid reprocessing
                  $icon.data('converted', true);
              }
          });
      }
      
      // Convert icons on page load
      convertMaterialIcons();
      
      // Convert icons after DataTables draw
      $(document).on('draw.dt', '.js-datatable', function() {
          convertMaterialIcons();
      });
      
      // Convert icons after any AJAX complete
      $(document).ajaxComplete(function() {
          setTimeout(convertMaterialIcons, 100); // Small delay to ensure DOM is updated
      });

        $('.select').select2({
            allowClear: true,
            dropdownCssClass : 'no-search'
        });

        $.views.settings.delimiters("[[", "]]");


        $('.datepicker').datepicker({
            zIndexOffset: 1000,
            format: 'dd-mm-yyyy'
        });

        $('.js-beInputList').beInputList();

        $('[data-toggle="tooltip"],.has-tooltip').tooltip();
        $('[data-toggle="popover"],.has-popover').popover();

        $('.navbar-toggle').sideNav({ menuWidth: 260, closeOnClick: true });

        function initTinyMce(){
            var tiny = tinymce.init({
                selector: '.js-tinymce',
                menubar: false,
                statusbar: false,
                automatic_uploads: false,
                skin_url: window.location.origin + '/css/tinymce',
                charLimit : 800,
                plugins: [
                    'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                    'searchreplace wordcount visualblocks visualchars code fullscreen',
                    'insertdatetime media nonbreaking save table contextmenu directionality',
                    'emoticons template paste textcolor colorpicker textpattern imagetools codesample toc'
                ],
                toolbar1: 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
                toolbar2: 'print preview media | forecolor backcolor emoticons | codesample',
                image_advtab: true,
                setup: function(editor) {
                    editor.on('change', function () {
                        editor.save();
                    });
                }
            });
            return tiny;
        }
        initTinyMce();

        /// RIPPLES

        var withRipples = [
            '.btn:not(.withoutripple)',
            '.card-image',
            '.navbar a:not(.withoutripple)',
            '.dropdown-menu a',
            '.nav-tabs a:not(.withoutripple)',
            '.withripple'
        ].join(',');

        $('body').find(withRipples).ripples();


        /// ANIMATED INPUT

        window.setAnimatedInputs = function(){

            $('.form-control').each(function (e,i){
                // Add class filled to form-control's that have a value
                var input = $(this);

                if($(this).val()){
                    $(this).parent('.form-group').addClass('filled');
                }
                // Animate form labels
                $(this).on('blur', function (e) {
                    if(input.val()){
                        input.parent('.form-group').addClass('filled');
                    } else {
                        input.parent('.form-group').removeClass('filled');
                    }
                    input.parent('.form-group').removeClass('is-active');
                }).on('focus', function (e) {
                    input.parent('.form-group').addClass('is-active');
                });
            });

            $('.o-filter__toggle').on('click',function(){
                $(this).parent('.o-filter').toggleClass('is-open')
            });
        };

        window.setAnimatedInputs();


        /// STUDENT


        $('.js-confirmation').confirmation({
            title : '¿Estás seguro?',
            btnOkClass : 'btn-sm btn-primary flush',
            btnOkLabel : 'Si',
            btnCancelClass : 'btn-sm btn-danger flush',
            btnCancelLabel : 'No',
            popout : true
        });

        $("#invite_offer").confirmation({
            title : '¿Estás seguro de invitar?',
            btnOkClass : 'btn-sm btn-primary flush',
            btnOkLabel : 'Si',
            btnCancelClass : 'btn-sm btn-danger flush',
            btnCancelLabel : 'No',
            popout : true,
            onConfirm : function(){
                var offerId = $('.js-autocomplete-offers-to-invite').val();
                var userId = $('input[name=id]').val();
                var $that = $(this);
                $that.prop('disabled');
                $.ajax({
                    type : "POST",
                    data : {oid:offerId,id:userId},
                    url : window.location.origin + '/admin/student/invite',
                    success : function(data){
                        $that.prop('disabled',false);
                        $.notify({
                            message: 'Usuario invitado a la oferta'
                        },{
                            element: '.alert-container-top-right',
                            type: 'success'
                        });
                    },
                    error : function(data){
                        console.info(data);
                        $.notify({
                            message: 'Error al invitar'
                        },{
                            element: '.alert-container-top-right',
                            type: 'warning'
                        });
                        $that.removeClass('btn-secondary').addClass('btn-warning');
                    }
                });
            }
        });

        $('.js-reset-pass').confirmation({
            title : '¿Cambiar contraseña?',
            btnOkClass : 'btn-sm btn-primary flush',
            btnOkLabel : 'Si',
            btnCancelClass : 'btn-sm btn-danger flush',
            btnCancelLabel : 'No',
            popout : true,
            onConfirm : function(){
                var offerId = $('.js-autocomplete-offers-to-invite').val();
                var userId = $('input[name=id]').val();
                var $that = $(this);
                $that.addClass('disabled');
                $.ajax({
                    type: "POST",
                    data: {id: userId},
                    url: window.location.origin + '/admin/student/reset-password',
                    success: function(data){
                        $(".js-reset-pass__input").val(data).parent().addClass('filled');
                        $('.js-reset-pass__send').prop('disabled',false)
                            .removeClass('btn-secondary').addClass('btn-success');
                        $that.prop('disabled',false);
                        $.notify({
                            message: 'Contraseña actualizada'
                        },{
                            element: '.alert-container-top-right',
                            type: 'success'
                        });
                    },
                    error : function(data){
                        $.notify({
                            message: 'Error al actualizar'
                        },{
                            element: '.alert-container-top-right',
                            type: 'warning'
                        });
                        $that.removeClass('btn-secondary').addClass('btn-warning');
                    }
                });
            }
        });

        $('.js-discard-student').confirmation({
            title : '¿Descartar de la oferta?',
            btnOkClass : 'btn-sm btn-primary flush',
            btnOkLabel : 'Si',
            btnCancelClass : 'btn-sm btn-danger flush',
            btnCancelLabel : 'No',
            popout : true,
            onConfirm : function(){
                var element = $(this);
                var oid = element.attr('data-oid');
                var sid = element.attr('data-sid');
                var cid = element.attr('data-cid');
                var cuid = element.attr('data-cuid');

                $.ajax({
                    type: "POST",
                    data: {oid:oid,sid:sid,cid:cid,cuid:cuid},
                    url: window.location.origin + '/admin/student/discard',
                    success: function(data){
                        element.hide();
                    }
                });
            }
        });

        $('.js-upload-candidate-image').beUpload({
            type            : 'student',
            img             : '#js-upload-user__img',
            ctype           : 'horizontal',
            size            : {width: 200,height: 200},
            width           : 200,
            height          : 200
        });

        $('.js-beNew').beNew({
            type            : 'news',
            img             : '#js-upload-user__img',
            ctype           : 'horizontal'
        });

        $('.js-beUpload').beUpload();

        $('.js-beLocation').beLocation();

        $('.js-beForm').beForm();

        $('.js-beEVP').beEVP();

        $('.js-beUserByCompany').beUserByCompany();

        $('.js-beCompanyManagement').beCompanyManagement();

        $('.js-beLanding').beLanding();

        $('.js-beAdminUsers').beAdminUsers();

        $('.js-beStudent').beStudent();

        $('.js-beOffer').beOffer();

        $('.js-beGroupOffers').beGroupOffers();

        $('.js-beContentPackage').beContentPackage();

        $('.js-beMessaging').beMessaging();

        $('.js-beAnnex').beAnnex();

        $('.js-beBlog').beBlog();

        $('.js-bePages').bePages();

        $('.js-beSummerNote').beSummerNote();

        $('.js-beInvoices').beInvoices();

        $('.js-beCustomization').beCustomization();

        $('.js-beDynamicFields').beDynamicFields();
        /// END STUDENT

      $('.js-beProduct').beProduct();

      $('.js-beOrder').beOrder();

      $('.summernote').summernote({
            height: 200,
            defaultFontName: 'Muli',
            fontNames: summernoteFonts,
            fontNamesIgnoreCheck: summernoteFonts,
            fontSizes: ['8', '9', '10', '11', '12', '13', '14', '16', '18', '20', '22', '24', '36', '48'],
            lineHeight: '120%',
            toolbar: [
                ['color', ['color']],
                ['insert', ['link']],
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['fontsize', ['fontsize']],
                ['fontname', ['fontname']],
            ],
            callbacks: {
                onPaste: function (e) {
                    var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                    e.preventDefault();
                    document.execCommand('insertText', false, bufferText);
                }
            }
        });

        $('.summernote-full').summernote({
            height: 150,
            focus: true,
            toolbar: [
                ['myotherbutton', ['parametros']],
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture', 'hr', 'codeview']]
            ],
        });

    });

    $(window).ready(function() {
        var url = document.location.toString();
        if (url.match('#')) {
            $('.js-tabs-nav a[href="#' + url.split('#')[1] + '"]').tab('show');
        }

        // Change hash for page-reload
        $('.js-tabs-nav a').on('shown.bs.tab', function (e) {
            window.location.hash = e.target.hash;
        });

        if($('.js_offer_active').hasClass('active')) {
            $('.js_offer_active').trigger('click');
        }

        $('body').addClass('loaded');
    });
});
